























































import { defineComponent, PropType, ref, watch, computed } from '@vue/composition-api';
import RecoPlayer from '@/components/player/reco-player.vue';
import FeedInfo from './info.vue';
import SideBar from './sidebar.vue';
import FeedSwitch from './switch.vue';
import { Feed, Maybe } from '@/generated-models';
import { useBroadcast } from '@/common/utils';
import { SwitchType } from '../types';
import { useRefetchVideo } from '../hooks';
import { useVideoMuted } from '@/common/useVideoMuted';
export default defineComponent({
    props: {
        index: {
            type: Number,
            default: 0,
        },
        activeIndex: {
            type: Number,
            default: 0,
        },
        feedItem: {
            type: Object as PropType<Maybe<Feed>>,
        },
        commentCount: {
            type: Number,
        },
        logType: {
            type: String,
            default: '',
        },
        isFullscreen: Boolean,
        muted: Boolean,
    },
    components: {
        RecoPlayer,
        FeedInfo,
        SideBar,
        FeedSwitch,
    },
    setup(props, { emit }) {
        const feedName = ref('newRecoFeed');
        const broadcast = useBroadcast();
        const videoInfo = computed(() => props.feedItem?.photo as { [key: string]: any;});
        const photoId = computed(() => props.feedItem?.photo?.id || '');
        const { curPhoto } = useRefetchVideo(photoId);
        const videoResource = computed(() => curPhoto.value.videoResource || props.feedItem?.photo?.videoResource);
        const fallbackUrl = computed(() => curPhoto.value.photoUrl || props.feedItem?.photo?.photoUrl);
        const { muted, canChangeVolume } = useVideoMuted(videoInfo);
        const realMuted = computed(() => muted.value || props.muted);
        function handleFullscreen(isFullscreen: boolean) {
            emit('fullscreen-change', isFullscreen);
            broadcast('change-tooltip-mode', isFullscreen);
        }
        function handleVolume(val: boolean) {
            emit('muted-change', val);
        }
        function handleEnded() {
            broadcast('reload-reco-video', {
                playerIndex: props.activeIndex,
            });
        }
        function handleSwitch(type: SwitchType) {
            emit('feed-change', type);
        }
        function handleCopyShare() {
            emit('copy-share');
        }
        function handleFeedback() {
            emit('feed-back');
        }
        function handleClickSidebar(type: string) {
            emit('click-sidebar', type);
        }
        return {
            feedName,
            videoResource,
            fallbackUrl,
            canChangeVolume,
            realMuted,
            handleFullscreen,
            handleVolume,
            handleEnded,
            handleSwitch,
            handleCopyShare,
            handleFeedback,
            handleClickSidebar,
        };
    },
});
